var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIceMocha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BAD1C1;}\n\t.st1{fill:#E0E0E0;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#B17F4A;}\n\t.st4{opacity:0.41;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.21,183.55c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.91,149.26,62.52,183.55,105.21,183.55"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.96,95.14c-0.62,0.23-1.24,0.48-1.86,0.75c-0.06,0.03-0.78,0.28-0.78,0.34l-0.1,14.26l1.29,0.92 c0,0,2.52,2.34,3.2-3.77c0.03-0.23,0.18-0.5,0.26-0.72c0.23-0.59,0.49-1.16,0.77-1.72c0.7-1.39,1.61-2.83,2.95-3.7 c1.56-1.01,3.25-0.57,4.61,0.58c0.48,0.41,0.9,0.87,1.3,1.36c0.61,0.76,1.16,1.63,1.43,2.59c0.29,1.06,0.21,2.23,0.18,3.32 c-0.03,1.43-0.2,2.85-0.51,4.25c-0.37,1.69-0.96,3.33-1.75,4.87c-0.93,1.8-2.16,3.43-3.61,4.84c-1.77,1.72-3.85,3.1-6.06,4.17 c-1.14,0.55-2.32,1.02-3.52,1.43c-0.66,0.22-1.32,0.42-1.99,0.61c-0.36,0.1-0.72,0.19-1.08,0.28c-0.12,0.03-1.04,0.16-1.07,0.25 c3.24-10.44,5.92-24.03,4.83-38.76h-0.86c0.75-0.5,1.14-1.02,1.14-1.54c0-3.22-14.08-5.82-31.45-5.82 c-17.37,0-31.45,2.6-31.45,5.82c0,0.53,0.4,1.04,1.12,1.54h-1.05c0,0-2.72,34.09,14.15,60.36c0,0,16.67,9.69,34.97-1.11 c0,0,1.68-2.85,3.87-7.84c1.08-0.57,2.94-1.71,6.06-3.98c0,0,20.21-9.7,21.98-21.91c0.05-0.37,0.13-0.74,0.19-1.11 c0.15-0.97,0.26-1.94,0.34-2.92c0.11-1.35,0.16-2.71,0.14-4.07c-0.02-1.53-0.14-3.05-0.4-4.56c-0.26-1.5-0.65-3-1.28-4.39 c-0.6-1.33-1.42-2.58-2.5-3.56c-1.15-1.04-2.56-1.74-4.07-2.08c-1.97-0.44-4.02-0.32-5.99,0.06 C139.18,94.41,138.06,94.74,136.96,95.14z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.93,
    y: 89.65,
    className: "st1",
    width: 1.79,
    height: 6.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "74.62,96.37 72.83,96.37 72.79,92.58 72.83,89.66 74.62,89.66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.88,90.66c-0.83-0.51-1.2-0.92-1.4-1.19c-0.62-0.81-0.78-1.63-0.86-2.05c-0.1-0.52-0.42-2.23,0.65-3.88 c1.06-1.65,2.76-2.07,3.13-2.16c-0.37-0.34-1.36-1.37-1.62-3.02c-0.9-5.72,6.48-6.86,10.56-7.11c-0.21-0.35-0.89-1.56-0.65-3.13 c0.27-1.77,1.51-2.77,1.83-3.02c1.95-1.51,4.71-1.29,7.02-1.53c3.56-0.38,2.71-4.36,3.43-6.83c0.45-1.54,1.77-2.26,3.24-2.63 c-0.26,0.07,0.25,1.43,0.37,1.56c0.44,0.51,1.26,0.57,1.89,0.59c2.03,0.04,4.09,0.15,5.93,1.09c0.55,0.28,1.49,0.77,2.26,1.83 c0.96,1.32,1.07,2.72,1.08,3.34c1.25,0.23,2.95,0.66,4.85,1.51c1.77,0.79,3.06,1.36,4.31,2.69c0.49,0.53,1.94,2.1,2.37,4.63 c0.29,1.7,0,3.11-0.22,3.88c1.7,0.55,3.1,1.21,4.2,1.83c2.91,1.63,4.49,3.55,4.96,6.9c0.26,1.84,0,3.27-0.11,3.77 c-0.47,2.26-2.92,3.19-4.85,3.99c-1.67,0.7-3.24,1.1-6.36,1.62c-4.75,0.79-8.38,1.06-8.62,1.08c-8.45,0.61-17.15,0.43-25.55-0.76 C84.97,93.14,80.17,92.67,76.88,90.66z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.05,116.66c0.28,1.79,0.62,3.57,1.01,5.34c1.47,6.62,3.56,13.34,6.15,19.62c1.09,2.64,2.47,7.23,5.33,8.34 c1.73,0.67,3.41,1.37,5.22,1.82c3.89,0.97,7.99,0.95,11.94,0.43c3.48-0.46,7.21-0.78,10.34-2.5c1.67-0.92,2-2.67,2.68-4.37 c1.72-4.33,3.5-8.67,4.97-13.1c1.6-4.8,4.3-16.71,4.96-20.74c0.66-4.03,1.43-13.24,1.43-13.24s-9.93,2.81-24.32,3.31 c-5.36,0.18-10.74-0.02-16.08-0.62c-2.67-0.3-5.34-0.7-7.98-1.22c-0.51-0.1-6.86-1.43-6.85-1.52 C76.3,104.2,77.11,110.73,78.05,116.66z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.55,
    y: 114.14,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 110.6422 -27.9133)",
    className: "st4",
    width: 10.92,
    height: 10.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.27,
    y: 105.81,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 216.9996 5.5433)",
    className: "st4",
    width: 10.92,
    height: 10.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.14,
    y: 123.08,
    transform: "matrix(0.4165 0.9092 -0.9092 0.4165 185.4885 -31.9123)",
    className: "st4",
    width: 10.92,
    height: 10.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.73,
    y: 136.37,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 262.7927 174.8052)",
    className: "st4",
    width: 10.92,
    height: 10.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.86,
    y: 122.9,
    transform: "matrix(0.0476 0.9989 -0.9989 0.0476 225.665 20.0491)",
    className: "st4",
    width: 10.92,
    height: 10.92
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceMocha);
export default __webpack_public_path__ + "static/media/Ice_Mocha.9996172f89e461a4d99b4ad4f8eb8fa3.svg";
export { ForwardRef as ReactComponent };